import * as MT from "./mutationTypes";
import Auth from "@/packages/auth";

export default {
  [MT.SET_SNACKBAR]: (state, data) => (state.snackbar = data),
  [MT.GET_USER]: state => {
    if (state.AuthModuleStore.user.id === null) {
      return (state.AuthModuleStore.user = JSON.parse(Auth.getUser()));
    }
    return state.AuthModuleStore.user;
  }
};
